module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cliente/cliente.component.html
// module id = ./src/app/cliente/cliente.component.html
// module chunks = main